import { SidePanelContainerStyled } from 'components/sidePanel/SidePanel.styles';
import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const IntegrationsTabsHeaderContainer = styled.div`
  ${SidePanelContainerStyled} {
    max-width: 60vw;

    ${mediaQuery.custom(575)} {
      margin-top: 60px;
    }
  }
`;
